import React from 'react';
import ContactAddress from './ContactAddress';

interface WidgetContactsProps {
  agencyDataAddress: string;
  agencyDataCity: string;
  agencyDataComuneCapoluogo: boolean;
  agencyDataProvinciaSigla: string;
  agencyDataEmail: string;
  agencyDataEmailShow: boolean;
  agencyDataPhone1: string;
  agencyDataPhone2?: string;
  agencyDataInternationalPrefix: string;
  agencyDataMobile?: string;
  agencyDataMobile2?: string;
  agencySocialShow?: boolean;
  agencyDataWhatsapp?: string;
  agencyDataFacebook?: string;
  agencyDataInstagram?: string;
  agencyDataTwitter?: string;
  agencyDataLinkedin?: string;
  agencyDataPinterest?: string;
  agencyDataYoutube?: string;
  agencyDataTikTok?: string;
  agencyDataThreads?: string;
}

export const widgetContacts: React.FC<WidgetContactsProps> = ({
  agencyDataAddress,
  agencyDataCity,
  agencyDataComuneCapoluogo,
  agencyDataProvinciaSigla,
  agencyDataEmail,
  agencyDataEmailShow,
  agencyDataPhone1,
  agencyDataPhone2,
  agencyDataInternationalPrefix,
  agencyDataMobile,
  agencyDataMobile2,
  agencySocialShow,
  agencyDataWhatsapp,
  agencyDataFacebook,
  agencyDataInstagram,
  agencyDataTwitter,
  agencyDataLinkedin,
  agencyDataPinterest,
  agencyDataYoutube,
  agencyDataTikTok,
  agencyDataThreads,
}) => {
  return (
      <ContactAddress
        agencyDataAddress={agencyDataAddress}
        agencyDataCity={agencyDataCity}
        agencyDataComuneCapoluogo={agencyDataComuneCapoluogo}
        agencyDataProvinciaSigla={agencyDataProvinciaSigla}
        agencyDataEmail={agencyDataEmail}
        agencyDataEmailShow={agencyDataEmailShow}
        agencyDataPhone1={agencyDataPhone1}
        agencyDataPhone2={agencyDataPhone2}
        agencyDataInternationalPrefix={agencyDataInternationalPrefix}
        agencyDataMobile={agencyDataMobile}
        agencyDataMobile2={agencyDataMobile2}
        agencySocialShow={agencySocialShow}
        agencyDataWhatsapp={agencyDataWhatsapp}
        agencyDataFacebook={agencyDataFacebook}
        agencyDataInstagram={agencyDataInstagram}
        agencyDataTwitter={agencyDataTwitter}
        agencyDataLinkedin={agencyDataLinkedin}
        agencyDataPinterest={agencyDataPinterest}
        agencyDataYoutube={agencyDataYoutube}
        agencyDataTikTok={agencyDataTikTok}
        agencyDataThreads={agencyDataThreads}
      />
  );
};

export default widgetContacts;